import { mergeArrays } from "./modules/utils";

const PlannerATLTypePolicy = {
  PlannerATL: {
    fields: {
      levels: {
        merge: mergeArrays,
      },
    },
  },
};
export default PlannerATLTypePolicy;
